import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {useState, useEffect} from 'react';
import useCourses from '../../../hooks/useCourses';
import { Link, useParams } from 'react-router-dom';
import GeneralErrorPage from '../../../components/errors/GeneralErrorPage';
// Removed DeckGame import - games moved to main site
import TableGame from '../../tables/games/TableGame';
import CourseLessonIntro from '../../../components/courses/CourseLessonIntro';
import useDecks from '../../../hooks/useDecks';
import { useLocation } from 'react-router-dom';


const CourseLesson = () => {
    let { courseId, lessonId } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isEmbed = queryParams.get('embed') === 'true';

    const {fetchCourseLesson, fetchCourseFromId} = useCourses();

    const {fetchAllItemsInSingleDeck} = useDecks();

    const [lesson, setLesson] = useState(null);
    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [contentGame, setContentGame] = useState(null);
    const [defaultDeckGame, setDefaultDeckGame] = useState("mix");
    const [defaultTableGame, setDefaultTableGame] = useState("fill-in");
    const [nextLessonId, setNextLessonId] = useState(null);
    const [currentPage, setCurrentPage] = useState("intro");
    const [deck, setDeck] = useState(null);
    const [deckCards, setDeckCards] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            console.log("Fetching course and lesson from id: ", lessonId)
            const resCourse = await fetchCourseFromId({courseId});
            setCourse(resCourse);
            console.log("Course: ", resCourse);
            if (resCourse !== null && resCourse.hasOwnProperty("lesson_ids")){
                let l = resCourse.lesson_ids;
                if (l !== null){
                    // find next lesson id if it exists
                    let lessonIndex = l.indexOf(parseInt(lessonId));
                    if (lessonIndex !== -1 && lessonIndex < l.length-1){
                        setNextLessonId(l[lessonIndex+1]);
                    } else {
                        setNextLessonId(null); 
                    }
                }
            }
            const results = await fetchCourseLesson({lessonId});
            console.log("lesson: ", results);
            setLesson(results);
            if (results !== null && results.hasOwnProperty("content_game")){
                setContentGame(results.content_game);
            }
            if (results !== null && results.hasOwnProperty("content_type") && results.content_type === "deck"){
                // fetch deck
                let deckId = results.content_id;
                let deckResults = await fetchAllItemsInSingleDeck(deckId, true);
                console.log("cards: ", deckResults);
                if (deckResults !== null && deckResults.hasOwnProperty("items")){
                    setDeckCards(deckResults.items);
                }
                if (deckResults !== null && deckResults.hasOwnProperty("deck")){
                    setDeck(deckResults.deck);
                }
            }
            setLoading(false);
        }

        if (lessonId === null || lessonId === undefined || fetchCourseLesson === undefined || courseId === null || courseId === undefined){return undefined}
        console.log("LessonID or courseID changed: ", lessonId, courseId);
        fetchData();
    }, [lessonId, courseId, fetchCourseLesson]);

    useEffect(()=>{
        if (isEmbed){
            setCurrentPage("content");
        }
    },[isEmbed]);

    const startLessonClick = () => {
        setCurrentPage("content");
    }

    return (
        <>
            <div>
                {loading &&
                    <>
                        <div className="h-screen w-screen fixed flex flex-col place-items-center justify-center text-4xl">
                            <FontAwesomeIcon icon={faSpinner} spin />
                        </div>
                    </>
                }
                {!loading &&
                    <>
                        {lesson === null &&
                            <div className="h-screen">
                                <GeneralErrorPage errorMessage={"Please verify that the lesson ID is correct and try again."} errorHeadline={"Lesson not found"} goBackLink={`/course/${courseId}`} goBackText={"Go back to course"} />
                            </div>
                        }
                        {lesson !== null &&
                            <>
                                {currentPage === "intro" &&
                                    <>
                                        <CourseLessonIntro course={course} startLessonClick={startLessonClick} lessonTitle={lesson.lesson_name} contentType={lesson.content_type} deck={deck} deckCards={deckCards} />
                                    </>
                                }
                                {currentPage === "content" &&
                                    <div>
                                        {lesson.content_type === "deck" &&
                                            <>
                                                <div className="">
                                                    <div className="text-center p-8 bg-gray-100 dark:bg-gray-800 rounded-lg">
                                                        <h3 className="text-lg font-semibold mb-2">Games Moved to Main Site</h3>
                                                        <p className="text-gray-600 dark:text-gray-400">Deck games have been moved to the main Yalango site for better performance and user experience.</p>
                                                        <Link to="/" className="inline-block mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                                                            Visit Main Site
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {lesson.content_type === "table" &&
                                            <>
                                                <div className="">
                                                    <TableGame isEmbed={isEmbed} type={"course"} nextLessonId={nextLessonId} backLink={`/course/${courseId}`} chosenHowManyItems={500} avoidParamsContentId={lesson.content_id} avoidParamsTargetLanguage={lesson["target_ISO_639-1"]} game={contentGame !== null ? contentGame : defaultTableGame} />
                                                </div>
                                            </>
                                        }
                                    </div>      
                                }
                            </>
                        }
                    </>
                }
            </div>
        </>
    )
}

export default CourseLesson;